import React from "react";
import { useState } from "react";
import AdminLayout from "../Layouts/AdminLayout";
import {
    Tabs,
    TabsContent,
    TabsList,
    TabsTrigger,
} from "@shadcn-in-nx/ui/tabs";
import Users from "../Profile/Users";
import ChatMessagesPanel from "./ChatMessagesPanel";
import { Users as UsersIcon, MessageSquare } from "lucide-react";
import { Outlet } from "react-router-dom";

export default function Admin() {
    const [activeTab, setActiveTab] = useState("users");

    return (
        <AdminLayout>
           <Outlet />
        </AdminLayout>
    );
}
